"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _metricsDidReceiveHandler = require("./metricsDidReceiveHandler");
Object.keys(_metricsDidReceiveHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _metricsDidReceiveHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _metricsDidReceiveHandler[key];
    }
  });
});